exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-ops__head[data-v-37e9996e]{display:flex;justify-content:flex-end;margin:0 0 8px}.pi-ops__lead[data-v-37e9996e]{margin-bottom:12px}.pi-ops__unmeasured[data-v-37e9996e]{color:#6b7280;cursor:help}.pi-ops__drops[data-v-37e9996e]{margin:0 0 12px;padding-left:18px;font-size:12px;color:#3a424e}.pi-page code[data-v-37e9996e]{padding:0;background:none;color:#1f2933;font-size:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-37e9996e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/restricted/productIntelligence/piOperations.vue
// module id = 1783
// module chunks = 0